/** Mirror of api permission-math for UI gating — plan/15. Keep in sync. */

export function hasActionPermission(
  held: readonly string[],
  needed: string,
): boolean {
  if (held.includes("*")) return true;
  return held.includes(needed);
}
